import {createFileRoute} from "@tanstack/react-router";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/debugger")({
    validateSearch: (search: Record<string, unknown>): {datasetId?: Uuid; workspaceId?: Uuid} => {
        const datasetIdResult = uuidZodValidator.safeParse(search.datasetId);
        const workspaceIdResult = uuidZodValidator.safeParse(search.workspaceId);
        return {
            ...(datasetIdResult.success === true ? {datasetId: datasetIdResult.data} : {}),
            ...(workspaceIdResult.success === true ? {workspaceId: workspaceIdResult.data} : {}),
        };
    },
    loader: async ({context}) => {
        return {
            accessToken: context.authenticationStatus.accessToken,
            intellsysBaseUrl: context.intellsysBaseUrl,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
